import styled from 'styled-components';
import { ToolBarSection } from 'tno-core';

export const CreateNewSection = styled(ToolBarSection)`
  .create-new {
    justify-content: center;
  }
`;
